import { useSession } from "@outschool/ui-auth";

import useExperiment from "./useExperiment";

/**
 * Experiment hook for the LearnerSpecificSearchV3 experiment.
 *
 * Control: Removes all learner-specific search functionality
 * Treatment: Preserves learner-specific search but only applies age filter (other preferences are ranking signals)
 * Holdout: Preserves learner-specific search.
 *
 * Note: showLearnerFilter => Whether to show the learner filter on the global search bar and listings pages.
 */
export default function useLearnerSpecificSearchV4Experiment() {
  const { variant, trigger } = useExperiment("LearnerSpecificSearchV4");
  const { isLoggedIn } = useSession();
  const showLearnerFilter = isLoggedIn && variant === "treatment";

  return {
    trigger,
    variant,
    showLearnerFilter,
  };
}
